import { applyUrlDefaults, queryParams, type RouteDefinition, type RouteQueryOptions } from './wayfinder';

/**
 * @see \Core\Crud\Http\Controllers\PortalCrudController::dashboard
 * @see src/Http/Controllers/PortalCrudController.php:26
 * @route '/crud'
 */
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
});

dashboard.definition = {
    methods: ['get', 'head'],
    url: '/crud',
} satisfies RouteDefinition<['get', 'head']>;

/**
 * @see \Core\Crud\Http\Controllers\PortalCrudController::dashboard
 * @see src/Http/Controllers/PortalCrudController.php:26
 * @route '/crud'
 */
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options);
};

/**
 * @see \Core\Crud\Http\Controllers\PortalCrudController::dashboard
 * @see src/Http/Controllers/PortalCrudController.php:26
 * @route '/crud'
 */
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
});

/**
 * @see \Core\Crud\Http\Controllers\PortalCrudController::dashboard
 * @see src/Http/Controllers/PortalCrudController.php:26
 * @route '/crud'
 */
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
});

/**
 * @see \Core\Crud\Http\Controllers\GlobalSearchController::globalSearch
 * @see src/Http/Controllers/GlobalSearchController.php:30
 * @route '/crud/global-search'
 */
export const globalSearch = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: globalSearch.url(options),
    method: 'get',
});

globalSearch.definition = {
    methods: ['get', 'head'],
    url: '/crud/global-search',
} satisfies RouteDefinition<['get', 'head']>;

/**
 * @see \Core\Crud\Http\Controllers\GlobalSearchController::globalSearch
 * @see src/Http/Controllers/GlobalSearchController.php:30
 * @route '/crud/global-search'
 */
globalSearch.url = (options?: RouteQueryOptions) => {
    return globalSearch.definition.url + queryParams(options);
};

/**
 * @see \Core\Crud\Http\Controllers\GlobalSearchController::globalSearch
 * @see src/Http/Controllers/GlobalSearchController.php:30
 * @route '/crud/global-search'
 */
globalSearch.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: globalSearch.url(options),
    method: 'get',
});

/**
 * @see \Core\Crud\Http\Controllers\GlobalSearchController::globalSearch
 * @see src/Http/Controllers/GlobalSearchController.php:30
 * @route '/crud/global-search'
 */
globalSearch.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: globalSearch.url(options),
    method: 'head',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::index
 * @see src/Http/Controllers/CrudController.php:39
 * @route '/crud/{model}'
 */
export const index = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
});

index.definition = {
    methods: ['get', 'head'],
    url: '/crud/{model}',
} satisfies RouteDefinition<['get', 'head']>;

/**
 * @see \Core\Crud\Http\Controllers\CrudController::index
 * @see src/Http/Controllers/CrudController.php:39
 * @route '/crud/{model}'
 */
index.url = (args: { model: string | number } | [model: string | number] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { model: args };
    }

    if (Array.isArray(args)) {
        args = {
            model: args[0],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
    };

    return index.definition.url.replace('{model}', parsedArgs.model.toString()).replace(/\/+$/, '') + queryParams(options);
};

/**
 * @see \Core\Crud\Http\Controllers\CrudController::index
 * @see src/Http/Controllers/CrudController.php:39
 * @route '/crud/{model}'
 */
index.get = (args: { model: string | number } | [model: string | number] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::index
 * @see src/Http/Controllers/CrudController.php:39
 * @route '/crud/{model}'
 */
index.head = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::create
 * @see src/Http/Controllers/CrudController.php:127
 * @route '/crud/{model}/create'
 */
export const create = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: create.url(args, options),
    method: 'get',
});

create.definition = {
    methods: ['get', 'head'],
    url: '/crud/{model}/create',
} satisfies RouteDefinition<['get', 'head']>;

/**
 * @see \Core\Crud\Http\Controllers\CrudController::create
 * @see src/Http/Controllers/CrudController.php:127
 * @route '/crud/{model}/create'
 */
create.url = (args: { model: string | number } | [model: string | number] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { model: args };
    }

    if (Array.isArray(args)) {
        args = {
            model: args[0],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
    };

    return create.definition.url.replace('{model}', parsedArgs.model.toString()).replace(/\/+$/, '') + queryParams(options);
};

/**
 * @see \Core\Crud\Http\Controllers\CrudController::create
 * @see src/Http/Controllers/CrudController.php:127
 * @route '/crud/{model}/create'
 */
create.get = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: create.url(args, options),
    method: 'get',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::create
 * @see src/Http/Controllers/CrudController.php:127
 * @route '/crud/{model}/create'
 */
create.head = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'head'> => ({
    url: create.url(args, options),
    method: 'head',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::store
 * @see src/Http/Controllers/CrudController.php:161
 * @route '/crud/{model}'
 */
export const store = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
});

store.definition = {
    methods: ['post'],
    url: '/crud/{model}',
} satisfies RouteDefinition<['post']>;

/**
 * @see \Core\Crud\Http\Controllers\CrudController::store
 * @see src/Http/Controllers/CrudController.php:161
 * @route '/crud/{model}'
 */
store.url = (args: { model: string | number } | [model: string | number] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { model: args };
    }

    if (Array.isArray(args)) {
        args = {
            model: args[0],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
    };

    return store.definition.url.replace('{model}', parsedArgs.model.toString()).replace(/\/+$/, '') + queryParams(options);
};

/**
 * @see \Core\Crud\Http\Controllers\CrudController::store
 * @see src/Http/Controllers/CrudController.php:161
 * @route '/crud/{model}'
 */
store.post = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::bulkAction
 * @see src/Http/Controllers/CrudController.php:397
 * @route '/crud/{model}/bulk-action'
 */
export const bulkAction = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'post'> => ({
    url: bulkAction.url(args, options),
    method: 'post',
});

bulkAction.definition = {
    methods: ['post'],
    url: '/crud/{model}/bulk-action',
} satisfies RouteDefinition<['post']>;

/**
 * @see \Core\Crud\Http\Controllers\CrudController::bulkAction
 * @see src/Http/Controllers/CrudController.php:397
 * @route '/crud/{model}/bulk-action'
 */
bulkAction.url = (args: { model: string | number } | [model: string | number] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { model: args };
    }

    if (Array.isArray(args)) {
        args = {
            model: args[0],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
    };

    return bulkAction.definition.url.replace('{model}', parsedArgs.model.toString()).replace(/\/+$/, '') + queryParams(options);
};

/**
 * @see \Core\Crud\Http\Controllers\CrudController::bulkAction
 * @see src/Http/Controllers/CrudController.php:397
 * @route '/crud/{model}/bulk-action'
 */
bulkAction.post = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'post'> => ({
    url: bulkAction.url(args, options),
    method: 'post',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::searchOptions
 * @see src/Http/Controllers/CrudController.php:438
 * @route '/crud/{model}/search-options'
 */
export const searchOptions = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: searchOptions.url(args, options),
    method: 'get',
});

searchOptions.definition = {
    methods: ['get', 'head'],
    url: '/crud/{model}/search-options',
} satisfies RouteDefinition<['get', 'head']>;

/**
 * @see \Core\Crud\Http\Controllers\CrudController::searchOptions
 * @see src/Http/Controllers/CrudController.php:438
 * @route '/crud/{model}/search-options'
 */
searchOptions.url = (args: { model: string | number } | [model: string | number] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { model: args };
    }

    if (Array.isArray(args)) {
        args = {
            model: args[0],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
    };

    return searchOptions.definition.url.replace('{model}', parsedArgs.model.toString()).replace(/\/+$/, '') + queryParams(options);
};

/**
 * @see \Core\Crud\Http\Controllers\CrudController::searchOptions
 * @see src/Http/Controllers/CrudController.php:438
 * @route '/crud/{model}/search-options'
 */
searchOptions.get = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: searchOptions.url(args, options),
    method: 'get',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::searchOptions
 * @see src/Http/Controllers/CrudController.php:438
 * @route '/crud/{model}/search-options'
 */
searchOptions.head = (
    args: { model: string | number } | [model: string | number] | string | number,
    options?: RouteQueryOptions,
): RouteDefinition<'head'> => ({
    url: searchOptions.url(args, options),
    method: 'head',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::show
 * @see src/Http/Controllers/CrudController.php:205
 * @route '/crud/{model}/{id}'
 */
export const show = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
});

show.definition = {
    methods: ['get', 'head'],
    url: '/crud/{model}/{id}',
} satisfies RouteDefinition<['get', 'head']>;

/**
 * @see \Core\Crud\Http\Controllers\CrudController::show
 * @see src/Http/Controllers/CrudController.php:205
 * @route '/crud/{model}/{id}'
 */
show.url = (args: { model: string | number; id: string | number } | [model: string | number, id: string | number], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            model: args[0],
            id: args[1],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
        id: args.id,
    };

    return (
        show.definition.url.replace('{model}', parsedArgs.model.toString()).replace('{id}', parsedArgs.id.toString()).replace(/\/+$/, '') +
        queryParams(options)
    );
};

/**
 * @see \Core\Crud\Http\Controllers\CrudController::show
 * @see src/Http/Controllers/CrudController.php:205
 * @route '/crud/{model}/{id}'
 */
show.get = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::show
 * @see src/Http/Controllers/CrudController.php:205
 * @route '/crud/{model}/{id}'
 */
show.head = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::preview
 * @see src/Http/Controllers/CrudController.php:232
 * @route '/crud/{model}/{id}/preview'
 */
export const preview = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: preview.url(args, options),
    method: 'get',
});

preview.definition = {
    methods: ['get', 'head'],
    url: '/crud/{model}/{id}/preview',
} satisfies RouteDefinition<['get', 'head']>;

/**
 * @see \Core\Crud\Http\Controllers\CrudController::preview
 * @see src/Http/Controllers/CrudController.php:232
 * @route '/crud/{model}/{id}/preview'
 */
preview.url = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
) => {
    if (Array.isArray(args)) {
        args = {
            model: args[0],
            id: args[1],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
        id: args.id,
    };

    return (
        preview.definition.url.replace('{model}', parsedArgs.model.toString()).replace('{id}', parsedArgs.id.toString()).replace(/\/+$/, '') +
        queryParams(options)
    );
};

/**
 * @see \Core\Crud\Http\Controllers\CrudController::preview
 * @see src/Http/Controllers/CrudController.php:232
 * @route '/crud/{model}/{id}/preview'
 */
preview.get = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: preview.url(args, options),
    method: 'get',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::preview
 * @see src/Http/Controllers/CrudController.php:232
 * @route '/crud/{model}/{id}/preview'
 */
preview.head = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'head'> => ({
    url: preview.url(args, options),
    method: 'head',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::viewerDetail
 * @route '/crud/{model}/{id}/viewer-detail'
 */
export const viewerDetail = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: viewerDetail.url(args, options),
    method: 'get',
});

viewerDetail.definition = {
    methods: ['get', 'head'],
    url: '/crud/{model}/{id}/viewer-detail',
} satisfies RouteDefinition<['get', 'head']>;

viewerDetail.url = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
) => {
    if (Array.isArray(args)) {
        args = {
            model: args[0],
            id: args[1],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
        id: args.id,
    };

    return (
        viewerDetail.definition.url.replace('{model}', parsedArgs.model.toString()).replace('{id}', parsedArgs.id.toString()).replace(/\/+$/, '') +
        queryParams(options)
    );
};

viewerDetail.get = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: viewerDetail.url(args, options),
    method: 'get',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::edit
 * @see src/Http/Controllers/CrudController.php:231
 * @route '/crud/{model}/{id}/edit'
 */
export const edit = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
});

edit.definition = {
    methods: ['get', 'head'],
    url: '/crud/{model}/{id}/edit',
} satisfies RouteDefinition<['get', 'head']>;

/**
 * @see \Core\Crud\Http\Controllers\CrudController::edit
 * @see src/Http/Controllers/CrudController.php:231
 * @route '/crud/{model}/{id}/edit'
 */
edit.url = (args: { model: string | number; id: string | number } | [model: string | number, id: string | number], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            model: args[0],
            id: args[1],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
        id: args.id,
    };

    return (
        edit.definition.url.replace('{model}', parsedArgs.model.toString()).replace('{id}', parsedArgs.id.toString()).replace(/\/+$/, '') +
        queryParams(options)
    );
};

/**
 * @see \Core\Crud\Http\Controllers\CrudController::edit
 * @see src/Http/Controllers/CrudController.php:231
 * @route '/crud/{model}/{id}/edit'
 */
edit.get = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::edit
 * @see src/Http/Controllers/CrudController.php:231
 * @route '/crud/{model}/{id}/edit'
 */
edit.head = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::update
 * @see src/Http/Controllers/CrudController.php:331
 * @route '/crud/{model}/{id}'
 */
export const update = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
});

update.definition = {
    methods: ['patch'],
    url: '/crud/{model}/{id}',
} satisfies RouteDefinition<['patch']>;

/**
 * @see \Core\Crud\Http\Controllers\CrudController::update
 * @see src/Http/Controllers/CrudController.php:331
 * @route '/crud/{model}/{id}'
 */
update.url = (args: { model: string | number; id: string | number } | [model: string | number, id: string | number], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            model: args[0],
            id: args[1],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
        id: args.id,
    };

    return (
        update.definition.url.replace('{model}', parsedArgs.model.toString()).replace('{id}', parsedArgs.id.toString()).replace(/\/+$/, '') +
        queryParams(options)
    );
};

/**
 * @see \Core\Crud\Http\Controllers\CrudController::update
 * @see src/Http/Controllers/CrudController.php:331
 * @route '/crud/{model}/{id}'
 */
update.patch = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
});

/**
 * @see \Core\Crud\Http\Controllers\CrudController::destroy
 * @see src/Http/Controllers/CrudController.php:357
 * @route '/crud/{model}/{id}'
 */
export const destroy = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
});

destroy.definition = {
    methods: ['delete'],
    url: '/crud/{model}/{id}',
} satisfies RouteDefinition<['delete']>;

/**
 * @see \Core\Crud\Http\Controllers\CrudController::destroy
 * @see src/Http/Controllers/CrudController.php:357
 * @route '/crud/{model}/{id}'
 */
destroy.url = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
) => {
    if (Array.isArray(args)) {
        args = {
            model: args[0],
            id: args[1],
        };
    }

    args = applyUrlDefaults(args);

    const parsedArgs = {
        model: args.model,
        id: args.id,
    };

    return (
        destroy.definition.url.replace('{model}', parsedArgs.model.toString()).replace('{id}', parsedArgs.id.toString()).replace(/\/+$/, '') +
        queryParams(options)
    );
};

/**
 * @see \Core\Crud\Http\Controllers\CrudController::destroy
 * @see src/Http/Controllers/CrudController.php:357
 * @route '/crud/{model}/{id}'
 */
destroy.delete = (
    args: { model: string | number; id: string | number } | [model: string | number, id: string | number],
    options?: RouteQueryOptions,
): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
});

const portalCrudmanager = {
    dashboard: Object.assign(dashboard, dashboard),
    globalSearch: Object.assign(globalSearch, globalSearch),
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    bulkAction: Object.assign(bulkAction, bulkAction),
    searchOptions: Object.assign(searchOptions, searchOptions),
    show: Object.assign(show, show),
    preview: Object.assign(preview, preview),
    viewerDetail: Object.assign(viewerDetail, viewerDetail),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    history: Object.assign(history, history),
};

export default portalCrudmanager;
